exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".truncatedDataNote{margin-bottom:15px;border:1px dashed #ddd;padding-top:12px;padding-bottom:5px;padding-left:10px}.truncatedDataNote .truncatedInner{margin:auto;width:80%}.truncatedDataNote .truncatedInner p{margin-bottom:0}.truncatedDataNote .truncatedInner p a{position:relative;bottom:1.4px}.truncatedDataNoteNoBorder{border:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/data/truncated_data_note.scss
// module id = 1316
// module chunks = 0